export default __webpack_public_path__ + "static/media/Photo.fd661e45.jpg";